
import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext, Store } from "@ngxs/store";
import { patch } from "@ngxs/store/operators";
import { CommonDataStateModel } from "../models/common-data.model";
import * as CommonDataActions from '../actions/common-data.action';

@State<CommonDataStateModel>({
    name: 'commonDataState',
    defaults: {
        // userCountry: "",
        apexId: "",
        dashboardTeamMessageDetails: null,
    }
})

@Injectable()
export class CommonDataState {
    constructor(
        private store: Store,
        //   private webApiService: WebApiService,
    ) { }


    @Selector()
    // static userCountry(state: CommonDataStateModel) {
    //     return state.userCountry;
    // }
    static apexId(state: CommonDataStateModel) {
        return state.apexId;
    }

    @Selector()    
    static dashboardTeamMessageDetails(state: CommonDataStateModel) {
        return state.dashboardTeamMessageDetails;
    }

    // @Action(CommonDataActions.SetUserCountry)
    // SetUserCountry(ctx: StateContext<CommonDataStateModel>, action: CommonDataActions.SetUserCountry) {
    //     ctx.setState(patch({ userCountry: action.countryCode }));
    // }
    @Action(CommonDataActions.SetUserCountry)
    SetUserApexId(ctx: StateContext<CommonDataStateModel>, action: CommonDataActions.SetUserApexId) {
        ctx.setState(patch({ apexId: action.apexId }));
    }

    @Action(CommonDataActions.SetUserCountry)
    SetDashboardTeamMessageDetails(ctx: StateContext<CommonDataStateModel>, action: CommonDataActions.SetDashboardTeamMessageDetails) {
        ctx.setState(patch({ dashboardTeamMessageDetails: action }));
    }

}